(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-usp-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUspSliders() {
      document.querySelectorAll('[data-usp-slider]').forEach(function (list) {
        var desktopLayout = list.dataset.desktopLayout;
        var mobileLayout = list.dataset.mobileLayout;
        var slideInterval = (parseInt(list.dataset.slideInterval, 10) || 3) * 1000;
        var items = Array.from(list.querySelectorAll('.usp-bar-block__item'));
        var mobileQuery = window.matchMedia('(max-width: 749px)');

        if (items.length <= 1) return;

        var currentIndex = 0;
        var timer = null;
        var sliderActive = false;

        function isSliderMode() {
          return mobileQuery.matches
            ? mobileLayout === 'slider'
            : desktopLayout === 'slider';
        }

        function showItem(index) {
          items.forEach(function (item, i) {
            if (i === index) {
              item.removeAttribute('aria-hidden');
            } else {
              item.setAttribute('aria-hidden', 'true');
            }
          });
          currentIndex = index;
        }

        function advance() {
          showItem((currentIndex + 1) % items.length);
        }

        function startTimer() {
          clearInterval(timer);
          timer = setInterval(function () {
            if (document.hidden) return;
            advance();
          }, slideInterval);
        }

        function activateSlider() {
          if (sliderActive) return;
          sliderActive = true;
          list.setAttribute('data-usp-slider-active', '');
          showItem(0);
          startTimer();
        }

        function deactivateSlider() {
          if (!sliderActive) return;
          sliderActive = false;
          list.removeAttribute('data-usp-slider-active');
          clearInterval(timer);
          timer = null;
          items.forEach(function (item) {
            item.removeAttribute('aria-hidden');
          });
        }

        function update() {
          if (isSliderMode()) {
            activateSlider();
          } else {
            deactivateSlider();
          }
        }

        // Pause on hover
        list.addEventListener('mouseenter', function () {
          if (sliderActive) clearInterval(timer);
        });
        list.addEventListener('mouseleave', function () {
          if (sliderActive) startTimer();
        });

        // Pause when tab is hidden
        document.addEventListener('visibilitychange', function () {
          if (!sliderActive) return;
          if (document.hidden) {
            clearInterval(timer);
          } else {
            startTimer();
          }
        });

        // React to viewport resize crossing the 750px breakpoint
        mobileQuery.addEventListener('change', update);

        // Initialize
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initUspSliders);
    } else {
      initUspSliders();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
